(() => {
  const normalize = (value) => value
    .toLocaleLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim();

  const noteGroups = [
    {
      key: 'agrumi',
      value: 'Agrumi',
      members: new Set([
        'agrumi', 'bergamotto', 'limone', 'mandarino', 'arancia',
        'arancia amara', 'pompelmo', 'lime', 'neroli', 'petitgrain',
        "fiori d'arancio", 'yuzu'
      ])
    },
    {
      key: 'spezie',
      value: 'Spezie',
      members: new Set([
        'spezie', 'cannella', 'cardamomo', 'pepe nero', 'pepe rosa',
        'coriandolo', 'cumino', 'zafferano', 'noce moscata', 'zenzero',
        'chiodi di garofano', 'anice', 'anice stellato'
      ])
    },
    {
      key: 'fiori',
      value: 'Fiori',
      members: new Set([
        'fiori', 'rosa', 'gelsomino', 'iris', 'tuberosa', 'ylang ylang',
        "fiori d'arancio", 'geranio', 'magnolia', 'neroli', 'violetta',
        'mughetto', 'fresia', 'peonia', 'camomilla', 'elicriso', 'hedione',
        'osmanto', 'ciclamino', 'eliotropio', 'fiori bianchi', 'gardenia',
        'mimosa'
      ])
    },
    {
      key: 'legni',
      value: 'Legni',
      members: new Set([
        'legni', 'patchouli', 'cedro', 'sandalo', 'vetiver', 'oud',
        'cipresso', 'cashmeran', 'legno di guaiaco', 'cypriol',
        'iso e super', 'legno di akigala', 'legno di quercia', 'papiro', 'pino'
      ])
    },
    {
      key: 'ambre_resine',
      value: 'Ambre e resine',
      members: new Set([
        'ambre e resine', 'ambra', 'incenso', 'ambra grigia', 'ambroxan',
        'mirra', 'benzoino', 'labdano', 'ambretta', 'cisto', 'elemi'
      ])
    },
    {
      key: 'muschi',
      value: 'Muschi',
      members: new Set(['muschi', 'muschio', 'muschio bianco', 'muschio di quercia'])
    },
    {
      key: 'frutti',
      value: 'Frutti',
      members: new Set(['frutti', 'ribes nero', 'fico', 'pera', 'pesca', 'ananas', 'lampone'])
    },
    {
      key: 'gourmand',
      value: 'Gourmand',
      members: new Set(['gourmand', 'vaniglia', 'fava tonka', 'cacao', 'mandorla', 'cocco'])
    },
    {
      key: 'aromatiche',
      value: 'Aromatiche',
      members: new Set([
        'aromatiche', 'ginepro', 'lavanda', 'galbano', 'menta', 'te',
        'mate', 'mirto', 'rosmarino', 'timo', 'pino', 'petitgrain'
      ])
    },
    {
      key: 'marine',
      value: 'Marine',
      members: new Set(['marine', 'note marine'])
    },
    {
      key: 'cuoio_tabacco',
      value: 'Cuoio e tabacco',
      members: new Set(['cuoio e tabacco', 'cuoio', 'tabacco'])
    }
  ];

  const smartNoteMenuGroups = [
    { key: 'citrus', sources: ['agrumi'] },
    { key: 'floral', sources: ['fiori'] },
    { key: 'woody', sources: ['legni'] },
    { key: 'spicy', sources: ['spezie'] },
    { key: 'amber', sources: ['ambre_resine'] },
    { key: 'fruit_gourmand', sources: ['frutti', 'gourmand'] },
    { key: 'green_aromatic', sources: ['aromatiche', 'marine'] },
    { key: 'musk_leather', sources: ['muschi', 'cuoio_tabacco'] }
  ];

  const smartNoteMenuCopy = () => {
    const locale = (document.documentElement.lang || 'it').slice(0, 2).toLowerCase();
    const copy = {
      it: { citrus: 'Agrumi', floral: 'Fiori', woody: 'Legni', spicy: 'Spezie', amber: 'Resine e note ambrate', fruit_gourmand: 'Frutti e note gourmand', green_aromatic: 'Note verdi e aromatiche', musk_leather: 'Muschi, cuoio e tabacco', other: 'Altre note' },
      de: { citrus: 'Zitrus', floral: 'Blüten', woody: 'Hölzer', spicy: 'Gewürze', amber: 'Harze und Ambernoten', fruit_gourmand: 'Früchte und Gourmandnoten', green_aromatic: 'Grüne und aromatische Noten', musk_leather: 'Moschus, Leder und Tabak', other: 'Weitere Noten' },
      fr: { citrus: 'Agrumes', floral: 'Fleurs', woody: 'Bois', spicy: 'Épices', amber: 'Résines et notes ambrées', fruit_gourmand: 'Fruits et notes gourmandes', green_aromatic: 'Notes vertes et aromatiques', musk_leather: 'Muscs, cuir et tabac', other: 'Autres notes' },
      en: { citrus: 'Citrus', floral: 'Florals', woody: 'Woods', spicy: 'Spices', amber: 'Resins and amber notes', fruit_gourmand: 'Fruits and gourmand notes', green_aromatic: 'Green and aromatic notes', musk_leather: 'Musks, leather and tobacco', other: 'Other notes' }
    };
    return copy[locale] || copy.en;
  };

  const fragranceFamilyGroups = [
    { key: 'citrus', aliases: ['agrumata', 'agrumato', 'zitrisch', 'citrus', 'agrumes'] },
    { key: 'aromatic', aliases: ['aromatica', 'aromatico', 'aromatisch', 'aromatic', 'aromatique'] },
    { key: 'floral', aliases: ['fiorita', 'fiorito', 'bluhend', 'floral', 'fleurie', 'fleur'] },
    { key: 'woody', aliases: ['legnosa', 'legnoso', 'holzig', 'woody', 'boisee', 'bois'] },
    { key: 'oriental', aliases: ['orientale', 'oriental'] },
    { key: 'spicy', aliases: ['speziata', 'speziato', 'wurzig', 'spicy', 'epicee'] },
    { key: 'leather', aliases: ['cuoiata', 'cuoiato', 'leder', 'ledrig', 'leather', 'cuir', 'cuiree'] },
    { key: 'sweet', aliases: ['dolce', 'suss', 'suß', 'sweet', 'douce', 'gourmand'] },
    { key: 'fruity', aliases: ['fruttata', 'fruttato', 'fruchtig', 'fruity', 'fruitee'] },
    { key: 'marine', aliases: ['marina', 'marino', 'maritim', 'marine'] },
    { key: 'musky', aliases: ['muschiata', 'muschiato', 'moschus', 'musky', 'musquee'] },
    { key: 'chypre', aliases: ['chypre'] },
    { key: 'fougere', aliases: ['fougere'] }
  ];

  const fragranceFamilyCopy = () => {
    const locale = (document.documentElement.lang || 'it').slice(0, 2).toLowerCase();
    const copy = {
      it: { citrus: 'Agrumato', aromatic: 'Aromatico', floral: 'Fiorito', woody: 'Legnoso', oriental: 'Orientale', spicy: 'Speziato', leather: 'Cuoio', sweet: 'Dolce', fruity: 'Fruttato', marine: 'Marino', musky: 'Muschiato', chypre: 'Chypre', fougere: 'Fougère', other: 'Altro' },
      de: { citrus: 'Zitrisch', aromatic: 'Aromatisch', floral: 'Blumig', woody: 'Holzig', oriental: 'Orientalisch', spicy: 'Würzig', leather: 'Leder', sweet: 'Süss', fruity: 'Fruchtig', marine: 'Maritim', musky: 'Moschus', chypre: 'Chypre', fougere: 'Fougère', other: 'Weitere' },
      fr: { citrus: 'Agrumes', aromatic: 'Aromatique', floral: 'Floral', woody: 'Boisé', oriental: 'Oriental', spicy: 'Épicé', leather: 'Cuir', sweet: 'Doux', fruity: 'Fruité', marine: 'Marin', musky: 'Musqué', chypre: 'Chypre', fougere: 'Fougère', other: 'Autres' },
      en: { citrus: 'Citrus', aromatic: 'Aromatic', floral: 'Floral', woody: 'Woody', oriental: 'Oriental', spicy: 'Spicy', leather: 'Leather', sweet: 'Sweet', fruity: 'Fruity', marine: 'Marine', musky: 'Musky', chypre: 'Chypre', fougere: 'Fougère', other: 'Other' }
    };
    return copy[locale] || copy.en;
  };

  const familyGroupForValue = (rawValue) => {
    const value = normalize(rawValue || '');
    return fragranceFamilyGroups.find((group) => group.aliases.includes(value));
  };

  const noteGroupCopy = () => {
    const locale = (document.documentElement.lang || 'it').slice(0, 2).toLowerCase();
    const copy = {
      it: {
        groups: { agrumi: 'Agrumi', spezie: 'Spezie', fiori: 'Fiori', legni: 'Legni', ambre_resine: 'Ambre e resine', muschi: 'Muschi', frutti: 'Frutti', gourmand: 'Gourmand', aromatiche: 'Aromatiche', marine: 'Marine', cuoio_tabacco: 'Cuoio e tabacco', other: 'Altre note' },
        all: { agrumi: 'Tutti gli agrumi', spezie: 'Tutte le spezie', fiori: 'Tutti i fiori', legni: 'Tutti i legni', ambre_resine: 'Tutte le ambre e resine', muschi: 'Tutti i muschi', frutti: 'Tutti i frutti', gourmand: 'Tutte le note gourmand', aromatiche: 'Tutte le aromatiche', marine: 'Tutte le note marine', cuoio_tabacco: 'Tutto cuoio e tabacco' },
        notes: 'note', title: 'Famiglia olfattiva', hint: 'Scegli una famiglia, poi togli le note che non desideri.', manual: 'Scegli una nota precisa'
      },
      de: {
        groups: { agrumi: 'Zitrus', spezie: 'Gewürze', fiori: 'Blüten', legni: 'Hölzer', ambre_resine: 'Amber & Harze', muschi: 'Moschus', frutti: 'Früchte', gourmand: 'Gourmand', aromatiche: 'Aromatisch', marine: 'Maritim', cuoio_tabacco: 'Leder & Tabak', other: 'Weitere Noten' },
        all: { agrumi: 'Alle Zitrusnoten', spezie: 'Alle Gewürze', fiori: 'Alle Blütennoten', legni: 'Alle Holznoten', ambre_resine: 'Alle Amber- und Harznoten', muschi: 'Alle Moschusnoten', frutti: 'Alle Fruchtnoten', gourmand: 'Alle Gourmandnoten', aromatiche: 'Alle aromatischen Noten', marine: 'Alle maritimen Noten', cuoio_tabacco: 'Alle Leder- und Tabaknoten' },
        notes: 'Noten', title: 'Duftfamilie', hint: 'Familie wählen und unerwünschte Noten einzeln entfernen.', manual: 'Bestimmte Duftnote wählen'
      },
      fr: {
        groups: { agrumi: 'Agrumes', spezie: 'Épices', fiori: 'Fleurs', legni: 'Bois', ambre_resine: 'Ambres & résines', muschi: 'Muscs', frutti: 'Fruits', gourmand: 'Gourmand', aromatiche: 'Aromatiques', marine: 'Marines', cuoio_tabacco: 'Cuir & tabac', other: 'Autres notes' },
        all: { agrumi: 'Tous les agrumes', spezie: 'Toutes les épices', fiori: 'Toutes les fleurs', legni: 'Tous les bois', ambre_resine: 'Tous les ambres et résines', muschi: 'Tous les muscs', frutti: 'Tous les fruits', gourmand: 'Toutes les notes gourmandes', aromatiche: 'Toutes les notes aromatiques', marine: 'Toutes les notes marines', cuoio_tabacco: 'Toutes les notes cuir et tabac' },
        notes: 'notes', title: 'Famille olfactive', hint: 'Choisissez une famille puis retirez les notes indésirables.', manual: 'Choisir une note précise'
      },
      en: {
        groups: { agrumi: 'Citrus', spezie: 'Spices', fiori: 'Florals', legni: 'Woods', ambre_resine: 'Amber & resins', muschi: 'Musks', frutti: 'Fruits', gourmand: 'Gourmand', aromatiche: 'Aromatic', marine: 'Marine', cuoio_tabacco: 'Leather & tobacco', other: 'Other notes' },
        all: { agrumi: 'All citrus notes', spezie: 'All spices', fiori: 'All florals', legni: 'All woods', ambre_resine: 'All amber and resin notes', muschi: 'All musks', frutti: 'All fruits', gourmand: 'All gourmand notes', aromatiche: 'All aromatic notes', marine: 'All marine notes', cuoio_tabacco: 'All leather and tobacco notes' },
        notes: 'notes', title: 'Fragrance family', hint: 'Choose a family, then remove individual notes you do not want.', manual: 'Choose an exact note'
      }
    };
    return copy[locale] || copy.en;
  };

  const dispatchBulkCheckboxChange = (inputs, checked) => {
    const changed = inputs.filter((input) => !input.disabled && input.checked !== checked);
    changed.forEach((input) => { input.checked = checked; });
    changed.at(-1)?.dispatchEvent(new Event('change', { bubbles: true }));
  };

  const groupForNote = (rawValue) => {
    const value = normalize(rawValue || '');
    return noteGroups.find((group) => group.members.has(value));
  };

  const organizeSelectedNoteGroups = (root = document) => {
    const copy = noteGroupCopy();

    root.querySelectorAll('[data-balu-note-selection-set]:not([data-balu-selected-note-groups])').forEach((selectionSet) => {
      const chips = [...selectionSet.querySelectorAll(':scope > .balu-smart-notes__chips > [data-balu-selected-note-option]')];
      if (!chips.length) return;

      const grouped = new Map(noteGroups.map((group) => [group.key, []]));
      const other = [];

      chips.forEach((chip) => {
        const group = groupForNote(chip.dataset.baluNoteValue);
        if (group) grouped.get(group.key).push(chip);
        else other.push(chip);
      });

      const fragment = document.createDocumentFragment();
      const appendSelectedGroup = (key, title, items) => {
        if (!items.length) return;
        const section = document.createElement('section');
        section.className = 'balu-note-selected';
        section.dataset.baluSelectedNoteGroup = key;
        section.innerHTML = `<header><strong>${title}</strong><small><span aria-hidden="true">✓</span>${items.length} ${copy.notes}</small></header>`;
        const list = document.createElement('div');
        list.className = 'balu-note-selected__values';
        items.forEach((chip) => list.append(chip));
        section.append(list);
        fragment.append(section);
      };

      noteGroups.forEach((group) => appendSelectedGroup(group.key, copy.groups[group.key], grouped.get(group.key)));
      appendSelectedGroup('other', copy.groups.other, other);
      selectionSet.replaceChildren(fragment);
      selectionSet.dataset.baluSelectedNoteGroups = 'true';
    });
  };

  const organizeNoteGroups = (root = document, openGroupKeys = new Set()) => {
    organizeSelectedNoteGroups(root);

    root.querySelectorAll('.balu-filter-values--notes:not([data-balu-note-groups])').forEach((values) => {
      const options = [...values.querySelectorAll(':scope > .checkbox-control')];
      if (!options.length) return;

      const grouped = new Map(noteGroups.map((group) => [group.key, []]));
      const other = [];

      options.forEach((option) => {
        const group = groupForNote(option.querySelector('input')?.value || option.textContent || '');
        if (group) grouped.get(group.key).push(option);
        else other.push(option);
      });

      const copy = noteGroupCopy();
      const assistant = document.createElement('section');
      assistant.className = 'balu-note-assistant';
      assistant.innerHTML = `<header><strong>${copy.title}</strong><small>${copy.hint}</small></header><div class="balu-note-assistant__scale"></div>`;
      const scale = assistant.querySelector('.balu-note-assistant__scale');

      const manual = document.createElement('details');
      manual.className = 'balu-note-manual';
      manual.dataset.baluNoteManual = 'notes';
      manual.open = openGroupKeys.size > 0;
      manual.innerHTML = `<summary><strong>${copy.manual}</strong><i aria-hidden="true"></i></summary><div class="balu-note-manual__groups"></div>`;
      const manualGroups = manual.querySelector('.balu-note-manual__groups');

      const appendGroup = (group, title, items) => {
        if (!items.length) return;

        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'balu-note-assistant__option';
        button.dataset.baluNoteGroupSelect = group.key;
        button.setAttribute('aria-label', copy.all[group.key] || title);
        button.innerHTML = `<strong>${title}</strong><small>${items.length}</small>`;
        scale.append(button);

        const section = document.createElement('section');
        section.className = 'balu-note-manual__group';
        section.dataset.baluNoteManualGroup = group.key;
        section.innerHTML = `<strong>${title}</strong>`;
        const list = document.createElement('div');
        list.className = 'balu-note-manual__values';
        items.forEach((option) => list.append(option));
        section.append(list);
        manualGroups.append(section);
      };

      noteGroups.forEach((group) => appendGroup(group, copy.groups[group.key], grouped.get(group.key)));
      appendGroup({ key: 'other' }, copy.groups.other, other);
      const search = values.closest('[data-balu-filter]')?.querySelector(':scope > .balu-filter-search');
      if (search) manual.insertBefore(search, manualGroups);
      values.replaceChildren(manual);
      values.before(assistant);
      values.dataset.baluNoteGroups = 'true';
    });
  };

  const organizeFragranceFamilies = (root = document) => {
    root.querySelectorAll('.balu-filter-studio .balu-filter-values--family:not([data-balu-family-assistant])').forEach((values) => {
      const options = [...values.querySelectorAll(':scope > .checkbox-control')];
      if (!options.length) return;

      const grouped = new Map(fragranceFamilyGroups.map((group) => [group.key, []]));
      const other = [];

      options.forEach((option) => {
        const input = option.querySelector('input[type="checkbox"]');
        const group = familyGroupForValue(input?.value || option.textContent || '');
        if (group) grouped.get(group.key).push(option);
        else other.push(option);
      });

      const copy = fragranceFamilyCopy();
      const assistant = document.createElement('div');
      assistant.className = 'balu-family-assistant';

      const raw = document.createElement('div');
      raw.className = 'balu-family-assistant__raw';
      raw.hidden = true;

      const appendFamily = (key, title, items) => {
        if (!items.length) return;

        const rawGroup = document.createElement('div');
        rawGroup.dataset.baluFamilyRawGroup = key;
        items.forEach((option) => rawGroup.append(option));
        raw.append(rawGroup);

        const inputs = items.map((option) => option.querySelector('input[type="checkbox"]')).filter(Boolean);
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'balu-family-assistant__option';
        button.dataset.baluFamilySelect = key;
        button.classList.toggle('is-active', inputs.some((input) => input.checked));
        button.setAttribute('aria-pressed', String(inputs.some((input) => input.checked)));
        // Le famiglie sono alternative tra loro (OR). Shopify puo restituire count=0
        // rispetto alla selezione corrente, ma il pulsante deve rimanere disponibile:
        // aggiungerlo puo ampliare l'insieme delle famiglie, mentre le note continuano
        // a restringere i risultati in AND.
        button.disabled = false;
        button.innerHTML = `<span>${title}</span><i aria-hidden="true">✓</i>`;
        assistant.append(button);
      };

      fragranceFamilyGroups.forEach((group) => appendFamily(group.key, copy[group.key], grouped.get(group.key)));
      appendFamily('other', copy.other, other);

      values.replaceChildren(assistant, raw);
      values.dataset.baluFamilyAssistant = 'true';
    });
  };

  const organizeSmartNoteMenus = (root = document) => {
    root.querySelectorAll('[data-balu-note-options]:not([data-balu-smart-note-menu])').forEach((values) => {
      const options = [...values.querySelectorAll(':scope > [data-balu-note-option]')];
      if (!options.length) return;

      const grouped = new Map(smartNoteMenuGroups.map((group) => [group.key, []]));
      const other = [];

      options.forEach((option) => {
        const rawGroup = groupForNote(option.querySelector('input')?.value || option.textContent || '')?.key;
        const menuGroup = smartNoteMenuGroups.find((group) => group.sources.includes(rawGroup));
        if (menuGroup) grouped.get(menuGroup.key).push(option);
        else other.push(option);
      });

      const copy = smartNoteMenuCopy();
      const fragment = document.createDocumentFragment();
      const appendGroup = (key, items) => {
        if (!items.length) return;
        const section = document.createElement('section');
        section.className = 'balu-smart-notes__group';
        section.dataset.baluNoteManualGroup = key;
        section.innerHTML = `<strong>${copy[key]}</strong>`;
        const list = document.createElement('div');
        list.className = 'balu-smart-notes__group-values';
        items.forEach((option) => list.append(option));
        section.append(list);
        fragment.append(section);
      };

      smartNoteMenuGroups.forEach((group) => appendGroup(group.key, grouped.get(group.key)));
      appendGroup('other', other);
      values.replaceChildren(fragment);
      values.dataset.baluSmartNoteMenu = 'true';
    });
  };

  const sizeGroupCopy = () => {
    const locale = (document.documentElement.lang || 'it').slice(0, 2).toLowerCase();
    const copy = {
      it: { title: 'La tua taglia abituale', hint: 'Seleziona uno scalarino, poi togli le equivalenze che non desideri.', selected: 'Equivalenze selezionate', manual: 'Scegli una taglia precisa' },
      de: { title: 'Deine übliche Grösse', hint: 'Grösse wählen und unerwünschte Entsprechungen einzeln entfernen.', selected: 'Gewählte Entsprechungen', manual: 'Bestimmte Grösse wählen' },
      fr: { title: 'Votre taille habituelle', hint: 'Choisissez une taille puis retirez les équivalences non souhaitées.', selected: 'Équivalences sélectionnées', manual: 'Choisir une taille précise' },
      en: { title: 'Your usual size', hint: 'Choose a size, then remove any equivalence you do not want.', selected: 'Selected equivalents', manual: 'Choose an exact size' }
    };
    return copy[locale] || copy.en;
  };

  const normalizeSize = (value) => normalize(value || '')
    .replace(/[–—−]/g, '-')
    .replace(/\s*-\s*/g, '-')
    .replace(/\s+/g, '');

  const universalSizeTokens = new Set(['uni', 'uni-uni', 'unica', 'onesize', 'one-size']);

  const universalSizeInputs = (values) => [...values.querySelectorAll('input[type="checkbox"]')]
    .filter((input) => universalSizeTokens.has(normalizeSize(input.value)));

  const sizeScales = {
    donna: {
      XXS: ['xxs', 'it-36', 'eu-32', '34', '36', '0'],
      XS: ['xs', 'xs/s', 'it-38', 'eu-34', '36', '38', '0'],
      S: ['s', 'xs/s', 's/m', 'it-40', 'eu-36', '38', '40', 'i'],
      M: ['m', 's/m', 'm/l', 'it-42', 'eu-38', '40', '42', 'ii'],
      L: ['l', 'm/l', 'l/xl', 'it-44', 'eu-40', '42', '44', 'iii'],
      XL: ['xl', 'l/xl', 'xl/xxl', 'it-46', 'eu-42', '44', '46', 'iv'],
      XXL: ['xxl', 'xl/xxl', 'it-48', 'it-50', 'eu-44', '46', 'v'],
      UNI: ['uni', 'uni-uni', 'unica', 'onesize']
    },
    uomo: {
      XS: ['xs', 'xs/s', 'it-44', 'eu-44', '44'],
      S: ['s', 'xs/s', 's/m', 'it-46', 'eu-46', '46', 'i'],
      M: ['m', 's/m', 'm/l', 'it-48', 'eu-48', '48', 'ii'],
      L: ['l', 'm/l', 'l/xl', 'it-50', 'eu-50', '50', 'iii'],
      XL: ['xl', 'l/xl', 'xl/xxl', 'it-52', 'eu-52', '52', 'iv'],
      XXL: ['xxl', 'xl/xxl', 'it-54', 'it-56', 'eu-54', 'eu-56', '54', '56', 'v', 'vi'],
      UNI: ['uni', 'uni-uni', 'unica', 'onesize']
    }
  };

  const sizeGenderContext = (values) => {
    const form = values.closest('facets-form');
    const genderInputs = [...form?.querySelectorAll('[data-balu-filter-key*="gender"] input[type="checkbox"]') || []];
    const selected = genderInputs.filter((input) => input.checked).map((input) => normalize(input.value));
    const available = genderInputs.map((input) => normalize(input.value));

    if (selected.some((value) => ['uomo', 'men', 'homme', 'herren'].includes(value))) return 'uomo';
    if (selected.some((value) => ['donna', 'women', 'femme', 'damen'].includes(value))) return 'donna';
    if (available.some((value) => ['uomo', 'men', 'homme', 'herren'].includes(value)) && !available.some((value) => ['donna', 'women', 'femme', 'damen'].includes(value))) return 'uomo';
    return 'donna';
  };

  const scaleInputs = (values, scaleKey) => {
    const gender = sizeGenderContext(values);
    const accepted = new Set(sizeScales[gender]?.[scaleKey] || []);
    return [...values.querySelectorAll('input[type="checkbox"]')].filter((input) => accepted.has(normalizeSize(input.value)));
  };

  const perfumeFormat = (rawValue) => {
    const normalized = normalize(rawValue || '')
      .replace(/\s+/g, '')
      .replace(',', '.');

    if (universalSizeTokens.has(normalized)) return { key: 'uni', label: 'UNI' };

    const match = normalized.match(/^(\d+(?:\.\d+)?)(ml|cl|l|g|kg)$/);
    if (!match) return { key: normalized, label: String(rawValue || '').trim() };

    const number = match[1].replace(/\.0+$/, '');
    return { key: `${number}${match[2]}`, label: `${number} ${match[2]}` };
  };

  const organizePerfumeFormats = (root = document) => {
    root.querySelectorAll('.balu-filter-values--format:not([data-balu-format-groups])').forEach((values) => {
      const options = [...values.querySelectorAll(':scope > .checkbox-control')];
      if (!options.length) return;

      const groups = new Map();
      options.forEach((option) => {
        const input = option.querySelector('input[type="checkbox"]');
        if (!input) return;

        const format = perfumeFormat(input.value);
        if (!groups.has(format.key)) groups.set(format.key, { ...format, options: [] });
        groups.get(format.key).options.push(option);
      });

      const raw = document.createElement('div');
      raw.dataset.baluFormatRaw = 'true';

      groups.forEach((group) => {
        group.options.forEach((option) => raw.append(option));
        if (group.key === 'uni' || !group.label) return;

        const inputs = group.options.map((option) => option.querySelector('input[type="checkbox"]'));
        const button = document.createElement('button');
        button.type = 'button';
        button.dataset.baluFormatSelect = group.key;
        button.textContent = group.label;
        button.classList.toggle('is-active', inputs.some((input) => input.checked));
        button.setAttribute('aria-pressed', String(inputs.some((input) => input.checked)));
        button.disabled = inputs.every((input) => input.disabled);
        values.append(button);
      });

      values.append(raw);
      values.dataset.baluFormatGroups = 'true';
    });
  };

  const organizeSizeGroups = (root = document, openManualKeys = new Set()) => {
    root.querySelectorAll('.balu-filter-values--size:not(.balu-filter-values--format):not([data-balu-size-groups])').forEach((values) => {
      const options = [...values.querySelectorAll(':scope > .checkbox-control')];
      if (!options.length) return;

      const copy = sizeGroupCopy();
      const filterKey = values.closest('[data-balu-filter-key]')?.dataset.baluFilterKey || 'size';
      const assistant = document.createElement('section');
      assistant.className = 'balu-size-assistant';
      assistant.innerHTML = `<header><strong>${copy.title}</strong><small>${copy.hint}</small></header><div class="balu-size-assistant__scale"></div>`;
      const scale = assistant.querySelector('.balu-size-assistant__scale');

      Object.keys(sizeScales[sizeGenderContext(values)]).forEach((scaleKey) => {
        const inputs = scaleInputs(values, scaleKey);
        if (!inputs.length) return;
        const checkedCount = inputs.filter((input) => input.checked).length;
        const button = document.createElement('button');
        button.type = 'button';
        button.dataset.baluSizeScale = scaleKey;
        button.textContent = scaleKey;
        button.classList.toggle('is-active', checkedCount === inputs.length);
        button.classList.toggle('is-partial', checkedCount > 0 && checkedCount < inputs.length);
        button.setAttribute('aria-pressed', String(checkedCount === inputs.length));
        scale.append(button);
      });

      const selectedOptions = options.filter((option) => option.querySelector('input:checked'));
      const otherOptions = options.filter((option) => !option.querySelector('input:checked'));

      if (selectedOptions.length) {
        const selected = document.createElement('section');
        selected.className = 'balu-size-selected';
        selected.innerHTML = `<strong>${copy.selected}</strong>`;
        const selectedValues = document.createElement('div');
        selectedValues.className = 'balu-size-selected__values';
        selectedOptions.forEach((option) => selectedValues.append(option));
        selected.append(selectedValues);
        values.append(selected);
      }

      if (otherOptions.length) {
        const manual = document.createElement('details');
        manual.className = 'balu-size-manual';
        manual.dataset.baluSizeManual = filterKey;
        manual.open = openManualKeys.has(filterKey);
        manual.innerHTML = `<summary><strong>${copy.manual}</strong><i aria-hidden="true"></i></summary>`;
        const manualValues = document.createElement('div');
        manualValues.className = 'balu-size-manual__values';
        otherOptions.forEach((option) => manualValues.append(option));
        manual.append(manualValues);
        values.append(manual);
      }

      values.before(assistant);
      values.dataset.baluSizeGroups = 'true';
    });
  };

  const organizePerformanceGroups = (root = document, keepOpen = false) => {
    root.querySelectorAll('.balu-filter-studio[data-balu-unified-studio]').forEach((studio) => {
      const grid = studio.querySelector('.balu-filter-studio__grid');
      if (!grid || grid.querySelector(':scope > [data-balu-performance-group]')) return;

      const scoreItems = [...grid.querySelectorAll(':scope > .balu-filter-step-item--score')];
      if (!scoreItems.length) return;

      const heading = grid.querySelector(':scope > .balu-filter-stage-heading');
      const group = document.createElement('details');
      group.className = 'balu-performance-compact balu-filter-step-item balu-filter-step-item--profile';
      group.dataset.baluPerformanceGroup = 'true';
      group.dataset.baluFilterStep = 'profile';
      group.open = keepOpen;

      const summary = document.createElement('summary');
      summary.textContent = heading?.textContent?.trim() || 'Performance';

      const content = document.createElement('div');
      content.className = 'balu-performance-compact__grid';
      scoreItems.forEach((item) => content.append(item));
      group.append(summary, content);

      if (heading) heading.replaceWith(group);
      else grid.append(group);
    });
  };

  const updateStudioCounts = (studio) => {
    studio.querySelectorAll('[data-balu-filter-step-trigger]').forEach((trigger) => {
      const step = trigger.dataset.baluFilterStepTrigger;
      const countTarget = trigger.querySelector('[data-balu-step-count]');
      const checked = [...studio.querySelectorAll(`[data-balu-filter-step="${step}"] input[type="checkbox"]:checked:not([data-score-value])`)]
        .filter((input) => !input.closest('.balu-family-assistant__raw')).length;
      const activeFamilies = studio.querySelectorAll(`[data-balu-filter-step="${step}"] [data-balu-family-select].is-active`).length;
      const count = checked + activeFamilies;

      if (countTarget) countTarget.textContent = count > 0 ? count : '';
    });
  };

  const activateStudioStep = (trigger) => {
    const studio = trigger.closest('.balu-filter-studio');
    if (!studio) return;

    const step = trigger.dataset.baluFilterStepTrigger;
    const title = studio.querySelector('[data-balu-filter-step-title]');
    const copy = studio.querySelector('[data-balu-filter-step-copy]');

    studio.dataset.baluActiveStep = step;

    studio.querySelectorAll('[data-balu-filter-step-trigger]').forEach((button) => {
      const active = button === trigger;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-selected', String(active));
    });

    if (title) title.textContent = trigger.dataset.stepTitle || '';
    if (copy) copy.textContent = trigger.dataset.stepCopy || '';
  };

  const initializeStudios = (root = document) => {
    organizeGenderSelectors(root);
    organizeFragranceFamilies(root);
    organizeSmartNoteMenus(root);
    organizePerfumeFormats(root);
    organizeSizeGroups(root);
    organizePerformanceGroups(root);
    root.querySelectorAll('.balu-filter-studio').forEach(updateStudioCounts);
    updateLiveResultCounts();
  };

  const updateLiveResultCounts = () => {
    const count = document.querySelector('.shopify-section--main-collection .collection-toolbar__products-count, .shopify-section--main-search .collection-toolbar__products-count');
    const label = count?.textContent?.replace(/\s+/g, ' ').trim() || '';
    const numericLabel = label.match(/\d[\d'’.\s]*/)?.[0]?.trim() || '';

    document.querySelectorAll('[data-balu-live-results]').forEach((target) => {
      target.textContent = label;
    });

    if (numericLabel) {
      document.querySelectorAll('[data-balu-result-button-count]').forEach((target) => {
        target.textContent = numericLabel;
      });
    }
  };

  let openNotesAfterFamilyChange = false;
  const facetsToKeepOpen = new Set();

  const facetDetails = (item) => item?.querySelector(
    ':scope > accordion-disclosure > details, :scope > details'
  );

  const rememberInteractedFacet = (element) => {
    const item = element?.closest?.('[data-balu-filter-key]');
    const key = item?.dataset.baluFilterKey;
    if (!key) return;

    facetsToKeepOpen.add(key);

    // Famiglie e note lavorano insieme: durante l'aggiornamento dinamico
    // devono rimanere entrambe visibili, senza obbligare il cliente a riaprirle.
    if (/famiglia_olfattiva|note_olfattive/i.test(key)) {
      item.closest('facets-form')?.querySelectorAll('[data-balu-filter-key]').forEach((candidate) => {
        const candidateKey = candidate.dataset.baluFilterKey || '';
        if (/famiglia_olfattiva|note_olfattive/i.test(candidateKey)) {
          facetsToKeepOpen.add(candidateKey);
        }
      });
    }
  };

  const genderKind = (value) => {
    const normalized = normalize(value || '');

    if (['donna', 'damen', 'woman', 'women', 'femme', 'femmes'].includes(normalized)) return 'female';
    if (['uomo', 'herren', 'man', 'men', 'homme', 'hommes'].includes(normalized)) return 'male';
    if (normalized.includes('unisex')) return 'unisex';
    return '';
  };

  const organizeGenderSelectors = (root = document) => {
    root.querySelectorAll('.balu-filter-values--gender').forEach((values) => {
      values.querySelectorAll(':scope > .checkbox-control').forEach((option) => {
        const input = option.querySelector('input[type="checkbox"]');
        const kind = genderKind(input?.value || option.textContent);
        if (!kind) return;

        option.dataset.baluGenderKind = kind;
        option.hidden = kind === 'unisex';
      });

      values.dataset.baluGenderGrouped = 'true';
    });
  };

  // Le famiglie sono un unico facet con valori alternativi (OR). Dopo aver
  // aggiornato i checkbox nascosti, costruiamo esplicitamente la richiesta
  // con tutti i valori selezionati: così il tema non perde i valori già attivi
  // quando il pulsante visuale viene usato al posto del checkbox nativo.
  const submitFamilyFacet = (familyButton) => {
    const facetsForm = familyButton.closest('facets-form');
    const form = facetsForm?.querySelector('form');
    const sectionId = facetsForm?.getAttribute('section-id');
    if (!form || !sectionId) return false;

    const url = new URL(form.action, window.location.origin);
    url.search = '';
    new FormData(form).forEach((value, key) => {
      if (value !== '') url.searchParams.append(key, value);
    });
    url.searchParams.set('section_id', sectionId);

    facetsForm.dispatchEvent(new CustomEvent('facet:update', {
      bubbles: true,
      detail: { url }
    }));
    return true;
  };

  const syncOpenFacetsFromSection = () => {
    const liveDrawer = document.querySelector('body > facets-drawer.facets-drawer[open]');
    const liveFacets = liveDrawer?.querySelector('facets-form');
    const sectionId = liveFacets?.getAttribute('section-id');
    const freshSection = sectionId ? document.getElementById(`shopify-section-${sectionId}`) : null;
    const freshFacets = freshSection?.querySelector('facets-drawer.facets-drawer facets-form');

    if (!liveFacets || !freshFacets) return;

    const activeStep = liveFacets.querySelector('.balu-filter-studio')?.dataset.baluActiveStep || 'essential';
    const viewportScrollY = window.scrollY;
    const viewportScrollX = window.scrollX;
    const keepOpenKeys = new Set(facetsToKeepOpen);
    const focusedId = document.activeElement?.id || '';
    const searchValues = new Map(
      [...liveFacets.querySelectorAll('[data-balu-filter-search]')].map((input) => [input.id, input.value])
    );
    const filterDetailsState = new Map(
      [...liveFacets.querySelectorAll('[data-balu-filter-key]')]
        .map((item) => [item.dataset.baluFilterKey, facetDetails(item)])
        .filter(([, details]) => details)
        .map(([key, details]) => [key, Boolean(details.open)])
    );
    const filterScrollPositions = new Map(
      [...liveFacets.querySelectorAll('[data-balu-filter-key]')].map((item) => [
        item.dataset.baluFilterKey,
        item.querySelector('[data-balu-filter-values]')?.scrollTop || 0
      ])
    );
    const openSizeManualKeys = new Set(
      [...liveFacets.querySelectorAll('[data-balu-size-manual][open]')].map((group) => group.dataset.baluSizeManual)
    );
    const noteManualWasOpen = Boolean(liveFacets.querySelector('[data-balu-note-manual][open]'));
    const performanceWasOpen = Boolean(liveFacets.querySelector('[data-balu-performance-group][open]'));
    const liveSmartNotes = liveFacets.querySelector('[data-balu-smart-notes]');
    const noteMenuWasOpen = liveSmartNotes?.classList.contains('is-note-menu-open') || openNotesAfterFamilyChange;
    const noteChooserWasVisible = Boolean(liveSmartNotes?.querySelector('[data-balu-note-chooser]:not([hidden])'));
    const replacement = freshFacets.cloneNode(true);

    // Il clone non conserva i listener JavaScript. I cursori della sezione
    // performance arrivano però con data-ready="true" dal blocco sorgente e,
    // senza questo reset, dopo il primo filtro sembrano attivi ma non reagiscono
    // più. Rimuovendo il flag vengono reinizializzati quando il clone entra nel DOM.
    replacement.querySelectorAll('balu-score-range[data-ready]').forEach((range) => {
      range.removeAttribute('data-ready');
    });

    replacement.querySelectorAll('[data-balu-filter-key]').forEach((item) => {
      const details = facetDetails(item);
      if (!details) return;

      const key = item.dataset.baluFilterKey;
      if (keepOpenKeys.has(key)) {
        details.open = true;
      } else if (filterDetailsState.has(key)) {
        details.open = filterDetailsState.get(key);
      }
    });

    liveFacets.replaceWith(replacement);
    organizeGenderSelectors(replacement);
    organizeFragranceFamilies(replacement);
    organizeSmartNoteMenus(replacement);
    organizePerfumeFormats(replacement);
    organizeSizeGroups(replacement, openSizeManualKeys);
    organizePerformanceGroups(replacement, performanceWasOpen);

    if (noteManualWasOpen) {
      const noteManual = replacement.querySelector('[data-balu-note-manual]');
      if (noteManual) noteManual.open = true;
    }

    const replacementSmartNotes = replacement.querySelector('[data-balu-smart-notes]');
    const replacementChooser = replacementSmartNotes?.querySelector('[data-balu-note-chooser]');
    if (replacementSmartNotes && replacementChooser && noteMenuWasOpen) {
      // Dopo una scelta di famiglia mostriamo subito l'unione delle note ancora
      // disponibili. Se era gia aperto il secondo campo, ne conserviamo lo stato.
      if (openNotesAfterFamilyChange || noteChooserWasVisible || !replacementChooser.classList.contains('is-secondary')) {
        replacementChooser.hidden = false;
        replacementSmartNotes.classList.add('is-note-menu-open');
        replacementSmartNotes.querySelector('[data-balu-add-second-note]')?.setAttribute('hidden', '');
      }
    }
    openNotesAfterFamilyChange = false;

    const studio = replacement.querySelector('.balu-filter-studio');
    const activeTrigger = studio?.querySelector(`[data-balu-filter-step-trigger="${activeStep}"]`);
    if (activeTrigger) activateStudioStep(activeTrigger);

    replacement.querySelectorAll('[data-balu-filter-search]').forEach((input) => {
      if (!searchValues.has(input.id)) return;
      input.value = searchValues.get(input.id);
      filterValues(input);
    });

    if (studio) updateStudioCounts(studio);

    replacement.querySelectorAll('[data-balu-filter-key]').forEach((item) => {
      const values = item.querySelector('[data-balu-filter-values]');
      const savedScrollTop = filterScrollPositions.get(item.dataset.baluFilterKey);
      if (values && Number.isFinite(savedScrollTop)) values.scrollTop = savedScrollTop;
    });

    if (focusedId) {
      const focusTarget = replacement.querySelector(`#${CSS.escape(focusedId)}`);
      focusTarget?.focus({ preventScroll: true });
    }

    // Il tema richiama scrollIntoView dopo il refresh dei prodotti. Ripristiniamo
    // la posizione del pannello anche dopo quel callback differito, evitando il
    // salto che faceva sembrare chiusi Famiglie e Note.
    const restoreViewport = () => window.scrollTo({
      top: viewportScrollY,
      left: viewportScrollX,
      behavior: 'auto'
    });
    requestAnimationFrame(restoreViewport);
    window.setTimeout(restoreViewport, 80);
    window.setTimeout(restoreViewport, 560);
    facetsToKeepOpen.clear();
  };

  const filterValues = (input) => {
    const wrapper = input.closest('[data-balu-filter]');
    const values = wrapper?.querySelector('[data-balu-filter-values]');
    const emptyState = wrapper?.querySelector('[data-balu-filter-empty]');

    if (!values) return;

    const query = normalize(input.value);
    let visibleCount = 0;

    values.querySelectorAll('.checkbox-control').forEach((option) => {
      const visible = normalize(option.textContent || '').includes(query);
      option.hidden = !visible;
      if (visible) visibleCount += 1;
    });

    values.querySelectorAll('[data-balu-note-manual-group]').forEach((group) => {
      const hasVisibleOption = [...group.querySelectorAll('.checkbox-control')].some((option) => !option.hidden);
      group.hidden = !hasVisibleOption;
    });

    const manual = values.querySelector('[data-balu-note-manual]');
    if (manual && query && visibleCount > 0) manual.open = true;

    if (emptyState) emptyState.hidden = visibleCount !== 0;
  };

  document.addEventListener('input', (event) => {
    if (event.target.matches('[data-balu-filter-search]')) {
      event.target.closest('[data-balu-smart-notes]')?.classList.add('is-note-menu-open');
      filterValues(event.target);
    }
  });

  document.addEventListener('search', (event) => {
    if (event.target.matches('[data-balu-filter-search]')) {
      filterValues(event.target);
    }
  });

  document.addEventListener('focusin', (event) => {
    if (event.target.matches('[data-balu-note-search]')) {
      event.target.closest('[data-balu-smart-notes]')?.classList.add('is-note-menu-open');
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Enter' && event.target.matches('[data-balu-filter-search]')) {
      event.preventDefault();
    }
  });

  // I chip del riepilogo vivono nel drawer spostato direttamente sotto <body>,
  // quindi il facet-link nativo non trova più la sezione Shopify più vicina.
  // Ricostruiamo l'URL con l'ID già presente sul facets-form del drawer.
  document.addEventListener('click', (event) => {
    const link = event.target.closest?.('body > facets-drawer facet-link a');
    if (!link) return;

    const sectionId = link.closest('facets-form')?.getAttribute('section-id');
    if (!sectionId) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const url = new URL(link.href, window.location.origin);
    url.searchParams.set('section_id', sectionId);
    link.dispatchEvent(new CustomEvent('facet:update', { bubbles: true, detail: { url } }));
  }, true);

  document.addEventListener('click', (event) => {
    const addSecondNote = event.target.closest('[data-balu-add-second-note]');
    if (addSecondNote) {
      const smartNotes = addSecondNote.closest('[data-balu-smart-notes]');
      const chooser = smartNotes?.querySelector('[data-balu-note-chooser]');
      if (chooser) chooser.hidden = false;
      addSecondNote.hidden = true;
      smartNotes?.classList.add('is-note-menu-open');
      requestAnimationFrame(() => chooser?.querySelector('[data-balu-note-search]')?.focus());
      return;
    }

    if (!event.target.closest('[data-balu-smart-notes]')) {
      document.querySelectorAll('[data-balu-smart-notes].is-note-menu-open').forEach((picker) => picker.classList.remove('is-note-menu-open'));
    }

    const formatButton = event.target.closest('[data-balu-format-select]');
    if (formatButton) {
      rememberInteractedFacet(formatButton);
      const values = formatButton.closest('.balu-filter-values--format');
      const key = formatButton.dataset.baluFormatSelect;
      const targets = [...values?.querySelectorAll('[data-balu-format-raw] input[type="checkbox"]') || []]
        .filter((input) => perfumeFormat(input.value).key === key && !input.disabled);
      const wasActive = targets.some((input) => input.checked);
      const changed = [];

      targets.forEach((input) => {
        const nextChecked = !wasActive;
        if (input.checked !== nextChecked) {
          input.checked = nextChecked;
          changed.push(input);
        }
      });

      if (!submitFamilyFacet(formatButton)) {
        changed.at(-1)?.dispatchEvent(new Event('change', { bubbles: true }));
      }
      return;
    }

    const familyButton = event.target.closest('[data-balu-family-select]');
    if (familyButton) {
      rememberInteractedFacet(familyButton);
      const values = familyButton.closest('.balu-filter-values--family');
      const key = familyButton.dataset.baluFamilySelect;
      const targets = [...values?.querySelectorAll(`[data-balu-family-raw-group="${CSS.escape(key)}"] input[type="checkbox"]`) || []]
        .filter((input) => !input.disabled);
      const wasActive = targets.some((input) => input.checked);
      const changed = [];

      targets.forEach((input) => {
        const nextChecked = !wasActive;
        if (input.checked !== nextChecked) {
          input.checked = nextChecked;
          changed.push(input);
        }
      });

      openNotesAfterFamilyChange = true;
      if (!submitFamilyFacet(familyButton)) {
        changed.at(-1)?.dispatchEvent(new Event('change', { bubbles: true }));
      }
      return;
    }

    const noteGroupSelect = event.target.closest('[data-balu-note-group-select]');
    if (noteGroupSelect) {
      const picker = noteGroupSelect.closest('[data-balu-filter]');
      const groupKey = noteGroupSelect.dataset.baluNoteGroupSelect;
      const group = picker?.querySelector(`[data-balu-note-manual-group="${CSS.escape(groupKey)}"]`);
      const inputs = [...group?.querySelectorAll('input[type="checkbox"]') || []];
      const allChecked = inputs.length > 0 && inputs.every((input) => input.checked);
      dispatchBulkCheckboxChange(inputs, !allChecked);
      return;
    }

    const sizeScaleButton = event.target.closest('[data-balu-size-scale]');
    if (sizeScaleButton) {
      const picker = sizeScaleButton.closest('[data-balu-filter]');
      const values = picker?.querySelector('[data-balu-filter-values]');
      if (!values) return;
      const inputs = scaleInputs(values, sizeScaleButton.dataset.baluSizeScale);
      const universalInputs = universalSizeInputs(values).filter((input) => !input.disabled);
      const isUniversalScale = sizeScaleButton.dataset.baluSizeScale === 'UNI';
      const allChecked = inputs.length > 0 && inputs.every((input) => input.checked);
      const nextChecked = !allChecked;
      const changed = [];

      inputs.forEach((input) => {
        if (!input.disabled && input.checked !== nextChecked) {
          input.checked = nextChecked;
          changed.push(input);
        }
      });

      if (!isUniversalScale) {
        const otherStandardSelected = [...values.querySelectorAll('input[type="checkbox"]')]
          .some((input) => !universalSizeTokens.has(normalizeSize(input.value)) && input.checked);
        const keepUniversal = nextChecked || otherStandardSelected;

        universalInputs.forEach((input) => {
          if (input.checked !== keepUniversal) {
            input.checked = keepUniversal;
            changed.push(input);
          }
        });
      }

      changed.at(-1)?.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

    const stepTrigger = event.target.closest('[data-balu-filter-step-trigger]');
    if (stepTrigger) {
      activateStudioStep(stepTrigger);
      return;
    }

    const button = event.target.closest('[data-balu-filter-expand]');
    if (!button) return;

    const picker = button.closest('[data-balu-filter]');
    const label = button.querySelector('[data-balu-filter-expand-label]');
    if (!picker) return;

    const expanded = picker.classList.toggle('is-expanded');
    button.setAttribute('aria-expanded', String(expanded));

    if (label) {
      label.textContent = expanded ? button.dataset.labelLess : button.dataset.labelMore;
    }
  });

  document.addEventListener('change', (event) => {
    rememberInteractedFacet(event.target);
    const studio = event.target.closest?.('.balu-filter-studio');
    if (studio) updateStudioCounts(studio);
  });

  // Il cliente sceglie soltanto Donna oppure Uomo. Ogni scelta include
  // automaticamente Unisex, mentre l'altro gruppo viene escluso.
  document.addEventListener('change', (event) => {
    const input = event.target.closest?.('.balu-filter-values--gender input[type="checkbox"]');
    if (!input) return;

    const kind = genderKind(input.value);
    if (kind !== 'female' && kind !== 'male') return;

    const values = input.closest('.balu-filter-values--gender');
    values.querySelectorAll('input[type="checkbox"]').forEach((candidate) => {
      const candidateKind = genderKind(candidate.value);

      if (candidateKind === 'unisex') {
        candidate.checked = input.checked;
      } else if (candidateKind && candidateKind !== kind) {
        candidate.checked = false;
      }
    });
  }, true);

  // Nella moda una variante UNI deve restare inclusa finché è attiva almeno
  // una taglia standard, anche dopo selezioni e deselezioni multiple.
  document.addEventListener('change', (event) => {
    const input = event.target.closest?.('.balu-filter-values--size:not(.balu-filter-values--format) input[type="checkbox"]');
    if (!input) return;

    const values = input.closest('.balu-filter-values--size');
    const universalInputs = universalSizeInputs(values).filter((candidate) => !candidate.disabled);
    if (!universalInputs.length) return;

    const inputIsUniversal = universalSizeTokens.has(normalizeSize(input.value));
    const standardSelected = [...values.querySelectorAll('input[type="checkbox"]')]
      .some((candidate) => !universalSizeTokens.has(normalizeSize(candidate.value)) && candidate.checked);

    if ((!inputIsUniversal && input.checked) || standardSelected) {
      universalInputs.forEach((candidate) => { candidate.checked = true; });
    } else if (!standardSelected) {
      universalInputs.forEach((candidate) => { candidate.checked = false; });
    }
  }, true);

  document.documentElement.addEventListener('theme:loading:end', () => {
    requestAnimationFrame(() => {
      syncOpenFacetsFromSection();
      updateLiveResultCounts();
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeStudios());
  } else {
    initializeStudios();
  }

  class BaluPriceRange extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      this.lower = this.querySelector('input[type="range"]:first-child');
      this.upper = this.querySelector('input[type="range"]:last-child');
      this.lowerField = this.querySelector('input[name="filter.v.price.gte"]');
      this.upperField = this.querySelector('input[name="filter.v.price.lte"]');
      this.rangeGroup = this.querySelector('.range-group');

      if (!this.lower || !this.upper || !this.lowerField || !this.upperField || !this.rangeGroup) return;

      const signal = this.abortController.signal;
      this.lowerField.addEventListener('focus', () => this.lowerField.select(), { signal });
      this.upperField.addEventListener('focus', () => this.upperField.select(), { signal });
      this.lowerField.addEventListener('change', () => this.syncFromFields('lower'), { signal });
      this.upperField.addEventListener('change', () => this.syncFromFields('upper'), { signal });
      this.lower.addEventListener('input', () => this.syncFromRange('lower', false), { signal });
      this.upper.addEventListener('input', () => this.syncFromRange('upper', false), { signal });
      this.lower.addEventListener('change', (event) => {
        event.stopPropagation();
        this.syncFromRange('lower', true);
      }, { signal });
      this.upper.addEventListener('change', (event) => {
        event.stopPropagation();
        this.syncFromRange('upper', true);
      }, { signal });
      this.paint();
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    numberOr(value, fallback) {
      const parsed = Number.parseInt(value, 10);
      return Number.isFinite(parsed) ? parsed : fallback;
    }

    syncFromFields(changedField) {
      const actualMax = this.numberOr(this.upperField.max, this.numberOr(this.upper.max, 4000));
      let lower = this.numberOr(this.lowerField.value, 0);
      let upper = this.numberOr(this.upperField.value, actualMax);

      lower = Math.max(0, Math.min(lower, actualMax - 1));
      upper = Math.min(actualMax, Math.max(upper, lower + 1));

      if (changedField === 'lower') this.lowerField.value = lower === 0 ? '' : lower;
      if (changedField === 'upper') this.upperField.value = upper === actualMax ? '' : upper;

      this.lower.value = Math.min(lower, Number(this.lower.max));
      this.upper.value = Math.min(upper, Number(this.upper.max));
      this.paint();
    }

    syncFromRange(changedHandle, commit) {
      const sliderMax = Number(this.upper.max);
      let lower = Number(this.lower.value);
      let upper = Number(this.upper.value);

      if (changedHandle === 'lower') lower = Math.min(lower, upper - 1);
      if (changedHandle === 'upper') upper = Math.max(upper, lower + 1);

      this.lower.value = lower;
      this.upper.value = upper;
      this.lowerField.value = lower === 0 ? '' : lower;
      this.upperField.value = upper === sliderMax ? '' : upper;
      this.paint();

      if (commit) {
        const field = changedHandle === 'lower' ? this.lowerField : this.upperField;
        field.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    paint() {
      const sliderMax = Math.max(Number(this.upper.max), 1);
      this.rangeGroup.style.setProperty('--range-min', `${Number(this.lower.value) / sliderMax * 100}%`);
      this.rangeGroup.style.setProperty('--range-max', `${Number(this.upper.value) / sliderMax * 100}%`);
    }
  }

  if (!customElements.get('balu-price-range')) {
    customElements.define('balu-price-range', BaluPriceRange);
  }

  class BaluScoreRange extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;

      this.dataset.ready = 'true';
      this.lower = this.querySelector('[data-score-lower]');
      this.upper = this.querySelector('[data-score-upper]');
      this.lowerOutput = this.querySelector('[data-score-lower-output]');
      this.upperOutput = this.querySelector('[data-score-upper-output]');
      this.options = [...this.querySelectorAll('[data-score-value]')];

      if (!this.lower || !this.upper || !this.options.length) return;

      this.lower.addEventListener('input', () => this.update('lower'));
      this.upper.addEventListener('input', () => this.update('upper'));
      this.lower.addEventListener('change', () => this.commit());
      this.upper.addEventListener('change', () => this.commit());
      this.paint();
    }

    update(changedHandle) {
      if (changedHandle === 'lower' && Number(this.lower.value) > Number(this.upper.value)) {
        this.lower.value = this.upper.value;
      }

      if (changedHandle === 'upper' && Number(this.upper.value) < Number(this.lower.value)) {
        this.upper.value = this.lower.value;
      }

      this.paint();
    }

    paint() {
      const min = Number(this.dataset.scoreMin);
      const max = Number(this.dataset.scoreMax);
      const span = Math.max(max - min, 1);
      const lowerProgress = ((Number(this.lower.value) - min) / span) * 100;
      const upperProgress = ((Number(this.upper.value) - min) / span) * 100;

      this.querySelector('.range-group')?.style.setProperty('--range-min', `${lowerProgress}%`);
      this.querySelector('.range-group')?.style.setProperty('--range-max', `${upperProgress}%`);
      this.lowerOutput.value = this.lower.value;
      this.upperOutput.value = this.upper.value;
    }

    commit() {
      const min = Number(this.dataset.scoreMin);
      const max = Number(this.dataset.scoreMax);
      const lower = Number(this.lower.value);
      const upper = Number(this.upper.value);
      const isFullRange = lower === min && upper === max;

      this.options.forEach((option) => {
        const value = Number(option.dataset.scoreValue);
        option.checked = !isFullRange && value >= lower && value <= upper;
      });

      this.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  if (!customElements.get('balu-score-range')) {
    customElements.define('balu-score-range', BaluScoreRange);
  }
})();
